export default {
  cardholder_name: 'Nume complet',
  cardholder_name_placeholder: 'Numele de pe card',
  card_number: 'Numărul cardului',
  card_number_placeholder: '1234 5678 9012 3456',
  expiry: 'Data expirării',
  expiry_placeholder: 'LL / AA',
  cvv: 'Cod de securitate',
  cvv_label: 'Cod de securitate (CVC)',
  cvv_placeholder: 'CVC',
  loading: 'Se inițializează formularul securizat de card…',
  sdk_load_failed:
    'Formularul securizat de card nu a putut fi încărcat. Verifică conexiunea și reîmprospătează pagina.',
  errors: {
    number_blank: 'Introdu numărul cardului.',
    number_invalid: 'Numărul cardului nu este valid. Verifică cifrele și încearcă din nou.',
    number_incomplete: 'Numărul cardului este incomplet.',
    cvv_blank: 'Introdu codul de securitate de pe spatele cardului.',
    cvv_invalid: 'Acest cod de securitate nu este valid. Verifică cele 3 sau 4 cifre de pe card.',
    cvv_incomplete: 'Introdu toate cele {{count}} cifre ale codului de securitate.',
    expiry_invalid: 'Introduceți o dată de expirare validă în format LL / AA.',
    expired: 'Acest card a expirat. Te rugăm să folosești alt card.',
    name_blank: 'Introdu numele exact așa cum apare pe card.',
    configuration: 'Plățile cu cardul nu sunt disponibile momentan. Te rugăm să încerci altă metodă de plată.',
    generic: 'Nu am putut verifica detaliile cardului. Te rugăm să încerci din nou.',
  },
};
